/* eslint-disable no-param-reassign */
import SiteDataHandler from 'src/services/SiteDataHandler';
import axios from 'axios';
import { toast } from 'react-toastify';
import { attatchScript } from 'globalUtils';
import i18next from 'i18next';
import createTheme from 'src/initialization/createTheme';
import { externalScriptsOnInit } from 'src/data/externalScripts';
import { translationsInit } from 'src/initialization/translationsInit';

const setAxiosErrorNotifications = () => {
	axios.interceptors.response.use(null, (error) => {
		if (
			error.config &&
			error.response &&
			error.config.method !== 'get'
			// process.env.NODE_ENV === 'development'
		) {
			const { endpointName, url, errorText } = error.config;
			const { status } = error.response;

			toast.error(
				error?.response?.data?.Message ||
					i18next.t(errorText) ||
					`HTTP error: ${
						endpointName || url
					} failed with a status code of ${status}`,
				{ autoClose: 5000 },
			);
		}

		return Promise.reject(error);
	});
};

const loadExternalScripts = () => {
	Object.keys(externalScriptsOnInit).forEach((s) => {
		const script = externalScriptsOnInit[s];
		if (!script.isDevOnly && process.env.NODE_ENV !== 'development') {
			attatchScript(script.src, script.attrs, script.node);
		}
		if (script.isDevOnly && process.env.NODE_ENV === 'development') {
			attatchScript(script.src, script.attrs, script.node);
		}
	});
};

// export const initializeServices = async () => {
export async function initializeServices() {
	setAxiosErrorNotifications();
	loadExternalScripts();

	const siteDataHandler = new SiteDataHandler({
		apiUrl: window.ENVIRONMENT.ApiRoot.Base,
		// If site data doesn't exist update the theme as soon as it's been retrieved.
		onAfterSetLocalStorage: (siteData) => createTheme(siteData),
	});

	await translationsInit();
	await siteDataHandler.init();

	return Promise.resolve();
}

export default initializeServices;
